import {
  Textarea as ChakraTextarea,
  type TextareaProps as ChakraTextareaProps
} from "@chakra-ui/react";

export type TextareaProps = Omit<ChakraTextareaProps, "size"> & {
  size?:
    | ChakraTextareaProps["size"]
    | string
    | Record<string, string>
    | Array<string | null>;
  invalid?: boolean;
};

export function Textarea({ size, invalid, ...props }: TextareaProps) {
  return (
    <ChakraTextarea
      size={size as ChakraTextareaProps["size"]}
      {...(invalid
        ? { "aria-invalid": true as const, "data-invalid": "" }
        : {})}
      {...props}
    />
  );
}
